import PageMeta from "../../components/common/PageMeta";
import {
  DEFAULT_PAGE_DESCRIPTION,
  DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import WidgetsStats from "../../components/dashboard/WidgetsStats";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";

const Dashboard = () => {
  return (
    <>
      <PageMeta
        title={`Dashboard - ${DEFAULT_PAGE_TITLE}`}
        description={`Dashboard - ${DEFAULT_PAGE_DESCRIPTION}`}
      />
      <PageBreadcrumb pageTitle="Overview" />
      <div className="space-y-6">
        <WidgetsStats />
      </div>
    </>
  );
};

export default Dashboard;
